import { TYPE_MAP } from '../IndexableYMME/constants'
import { EXCLUDED_PATHNAMES } from './constant'

export const ymmePageHasData = mainContent => mainContent.find(({ props: { type = '' } = {}}) => TYPE_MAP.includes(type))
export const isExcludedPathname = pathname => EXCLUDED_PATHNAMES.includes(pathname)

